import { createAction, handleActions } from 'redux-actions'

const setData = createAction('MODULES/TIMESHEETS_DRAWER/SET_DATA')
const resetData = createAction('MODULES/TIMESHEETS_DRAWER/RESET_DATA')

const defaultState = []

const reducer = handleActions(
  {
    [setData]: (state, { payload }) => payload,
    [resetData]: () => defaultState,
  },
  defaultState,
)

export { setData, resetData, reducer }
